<template>
   <nuxt-link
      
      :to="localePath(internalLink)"
      
    >
            <span>
              {{ link.label }}
            </span>
         
    </nuxt-link>
</template>

<script>
export default {
  name: 'Link',
}
</script>

<script setup>


const props = defineProps({
  link: Object,
})


const internalLink = computed(() => {
  let obj
  if (props.link.link.__typename === 'ExpertiseListingRecord') {
    obj = {
      name: 'expertise'
    }
    return obj
  }
  if (props.link.link.__typename === 'ExpertiseRecord') {
    obj = {
      name: 'expertise-slug', params: {slug: props.link.link.slug}
    }
    return obj
  }
  if (props.link.link.__typename === 'ContentsListingRecord') {
    obj = {
      name: 'contents'
    }
    return obj
  }
  if (props.link.link.__typename === 'ContentRecord') {
    obj = {
      name: 'contents-slug', params: {slug: props.link.link.slug}
    }
    return obj
  }
  if (props.link.link.__typename === 'IndustryListingRecord') {
    obj = {
      name: 'industries'
    }
    return obj
  }
  if (props.link.link.__typename === 'IndustryRecord') {
    obj = {
      name: 'industries-slug', params: {slug: props.link.link.slug}
    }
    return obj
  }
  if (props.link.link.__typename === 'SolutionsListingRecord') {
    obj = {
      name: 'solutions'
    }
    return obj
  }
  if (props.link.link.__typename === 'SolutionRecord') {
    obj = {
      name: 'solutions-slug', params: {slug: props.link.link.slug}
    }
    return obj
  }
  if (props.link.link.__typename === 'StudioPageRecord') {
    obj = {
      name: 'about-us'
    }
    return obj
  }
  if (props.link.link.__typename === 'AreYouAnAgencyRecord') {
    obj = {
      name: 'are-you-an-agency'
    }
    return obj
  }
  if (props.link.link.__typename === 'ContactPageRecord') {
    obj = {
      name: 'richiedi-progetto'
    }
    return obj
  }
})

onMounted(() => {
  
})

onUnmounted(() => {
  // Disconnect the observer when the component unmounts
 
})


</script>

<style lang="scss">
@import './style.scss';
</style>
